import React from "react";
import { Link } from "react-router-dom";
import ExternalLink from "../../../assets/externalLink";

interface ILinkInfo {
  title: string;
  targetLink: string;
  isExternalLink: boolean;
}

interface Props {
  jwt: string
}

const SublimationSubMenu = ({
  jwt
}: Props) => {
  const sublimationWebsite =
    process.env.REACT_APP_SUBLIMATION_WEBSITE;

  const subMenuLinks: ILinkInfo[] = [
    {
      title: "Design Your Way",
      targetLink: "",
      isExternalLink: false
    },
    {
      title: "Pricing",
      targetLink: "/pricing",
      isExternalLink: false
    },
    {
      title: "Style Sheets",
      targetLink: "/stylesheets",
      isExternalLink: false
    },
    {
      title: "Engineered Fabrics",
      targetLink: "/fabrics",
      isExternalLink: false
    },
    {
      title: "Education",
      targetLink: "/education",
      isExternalLink: false
    },
    {
      title: "Order Form",
      targetLink: "https://drive.google.com/drive/folders/1hMqqSwmOzFMB5TpN86c5MkaZBQFuVuf7?usp=drive_link",
      isExternalLink: true
    },
  ]

  const generateSubMenuLink = (category: ILinkInfo) => {
    const link = category.isExternalLink ? category.targetLink : `${sublimationWebsite}${category.targetLink}?jwt=${jwt}`;

    return (
      <Link
        to=""
        onClick={() => window.open(link, "_blank")}
      >
        <span style={{ textTransform: "capitalize" }}>
          {category.title}
        </span>
        <div className="expand-icon">
          <ExternalLink width={15} fill="white"/>
        </div>
      </Link>
    );
  };

  const generateSubmenu = (): JSX.Element | JSX.Element[] =>
     subMenuLinks.map((category, index) => (
      <div key={index} role="menuitem">
        {generateSubMenuLink(category)}
      </div>
    ));

  return <>{generateSubmenu()}</>;
};

export default SublimationSubMenu;
